import React, { useState, useEffect } from 'react'
import { Modal } from 'rsuite'
import Select from 'react-select'
import MasterInformation from './master-information'
import ChildSuppliersModal from './child-supplier-modal'

const MergeMastersModal = ({ show, onClose, selectedMasterIds, masterSuppliersData }) => {
    const [masterDetails, setMasterDetails] = useState([])
    const [selectedSuppliers, setSelectedSuppliers] = useState([])
    const [showChildSuppliersModal, setShowChildSuppliersModal] = useState(false)
    const handleChangeMasterSupplier = (value) => {
        setMasterDetails(masterSuppliersData.find(supplier => supplier?.id === value?.value))
    }

    const handleConfirmClick = () => {
        setShowChildSuppliersModal(true)
    }

    const handleClose = (closeMergeMasterModal = false) => {
        setShowChildSuppliersModal(false)
        if (closeMergeMasterModal) {
            onClose(closeMergeMasterModal)
        }
    }

    useEffect(() => {
        const selectedSuppliers = selectedMasterIds.map(supplierId => masterSuppliersData.find(supplier => supplierId === supplier?.id))
        setSelectedSuppliers(selectedSuppliers)
        setMasterDetails(selectedSuppliers[0])
    }, [])

    return (
        <>
            <Modal
                backdrop='static'
                className="merge-master-modal"
                show={show}
                size="lg"
                onClick={() => { onClose(false) }}
                onHide={() => { onClose(false) }}
            >
                <Modal.Header>
                    <Modal.Title className='text-black'>
                        Merge Master Suppliers
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="header row g-0 position-sticky top-0 pb-4 sticky-header bg-white">
                        <div className='col-8'>
                            <h4 className='fw-bold text-blue mb-0'>Master Supplier Information</h4>
                        </div>
                        <div className='col-4'>
                            <h3 className='fw-bold text-blue mb-0'>Master Suppliers</h3>
                            <Select
                                className='h4 mb-0 text-black mt-3'
                                onChange={(newValue) => handleChangeMasterSupplier(newValue)}
                                value={
                                    {
                                        label: masterDetails['suppliername'] || '',
                                        value: masterDetails['id'] || null
                                    }
                                }
                                options={
                                    selectedSuppliers?.map(supplier => (
                                        {
                                            label: supplier['suppliername'] || '',
                                            value: supplier['id'] || null
                                        }
                                    ))
                                    // selectedSuppliers?.filter((supplier, index, self) => supplier['suppliername'] && self.findIndex(item => item['suppliername'] === supplier['suppliername']) === index)?.map(supplier => (
                                    //     {
                                    //         label: supplier['suppliername'] || '',
                                    //         value: supplier['id'] || null,
                                    //     }
                                    // ))
                                }
                            />
                        </div>
                    </div>
                    <div className="content row g-0 pt-5">
                        <MasterInformation masterDetails={masterDetails} />
                    </div>
                </Modal.Body>
                <Modal.Footer className='pe-3'>
                    <div className="action-container float-end pe-3">
                        <button type="button" className="text-white rounded bg-green me-0 p-5 pt-3 pb-3 h4 mb-0" onClick={handleConfirmClick}>
                            Confirm
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>
            {showChildSuppliersModal && (
                <ChildSuppliersModal show={showChildSuppliersModal} onClose={handleClose} masterSupplierData={masterDetails} selectedMasterSuppliers={selectedSuppliers} />
            )}
        </>
    )
}
export default MergeMastersModal